<template>
  <div>
    <header class="section party-header" :style="{ background : success && (info.bg_color ? info.bg_color : '#f5d784')}">
      <div class="container">
        <div class="columns header is-vcentered is-hidden-mobile">
          <div class="column">
            <h1 class="title is-1 is-spaced">{{ info.title }}</h1>
            <div class="subtitle has-text-weight-medium has-text-justified">
              {{ info.desc }}
            </div>
            <a
              :href="`tel:+${config.phone}`"
              class="button is-primary has-text-weight-semibold mt-4"
              :style="{
                backgroundColor : config.button_bgcolor
              }"
              >Call Us</a
            >
            <div
              @click="openDialog"
              class="button is-primary is-rounded has-text-weight-semibold mb-3"
              :style="{
                backgroundColor : config.button_bgcolor
              }"
            >
              Booking Online
            </div>
          </div>
          <div class="column">
            <template v-if="info && info.video_url">
              <div class="image is-16by9">
                <div class="iframe-wrap" v-html="info.video_url"></div>
              </div>
            </template>
            <template v-else-if="info.image">
              <div class="image">
                <img alt="..." :src="info.image" />
              </div>
            </template>
          </div>
        </div>
        <div class="columns header is-hidden-tablet">
          <div class="column">
            <h1 class="title is-1 is-spaced">Party Package</h1>
            <div class="subtitle has-text-weight-medium has-text-justified">
              {{ info.desc }}
            </div>
            <a
              :href="`tel:+${config.phone}`"
              class="button is-primary has-text-weight-semibold mt-4"
              :style="{
                backgroundColor : config.button_bgcolor
              }"
            >
              Call Us
            </a>
            <div
              @click="openDialog"
              class="button is-primary is-rounded has-text-weight-semibold mb-3"
              :style="{
                backgroundColor : config.button_bgcolor
              }"
            >
              Booking Online
            </div>
          </div>
        </div>
      </div>
    </header>
    <section class="section">
      <div class="container has-text-white has-text-weight-semibold">
        <div class="columns price">
          <div
            class="column is-one-third"
            v-for="(item, index) in items"
            :key="index"
          >
            <div
              class="plan-1 has-text-weight-semibold py-4 px-2"
              :style="{ background: item.bg_color ? item.bg_color : background[index % 3] }"
            >
              <div class="columns is-mobile">
                <div class="column is-9">
                  <h3 class="title is-3 has-text-white mt-4 ml-2">
                    {{ item.title }}
                  </h3>
                  <h1 class="title is-1 has-text-white ml-2">
                    ${{ item.price }}
                  </h1>
                </div>
                <!-- :src="img[index % 3]" -->
                <img
                  v-if="item.icon_url"
                  :src="item.icon_url"
                  alt=""
                  class="image is-128x128 decoration"
                />
              </div>
              <ul class="px-2">
                <div class="enable_info" v-html="item.desc"></div>
                <!-- <li>Up to 10 kids with 10 adults</li>
                <li>2-hour party room</li>
                <li>2-hour same time play</li>
                <li>10% OFF with Unlimited Pass</li> -->
              </ul>
              <hr class="mx-1" />
              <ul class="px-2">
                <div class="enable_info" v-html="item.price_info"></div>
                <!-- <li>$50 deposit when booking</li>
                <li>$11.99 / add'l kid</li>
                <li>$7.99 / add'l toddler</li>
                <li>$5.99 / add'l adult</li>
                <li>$100 / add'l hour for party room and play</li>
                <li>$50 / add'l hour for play only</li> -->
              </ul>
              <hr class="mx-1" />
              <ul class="px-2">
                <!-- <li class="mb-4">
                  Available:
                  <ul class="pl-2">
                    <li>MONs - SUNs: Business hours</li>
                  </ul>
                </li>
                <li>Book anytime</li>
                <li>Reschedule or cancel 1 week prior</li> -->
                <div class="enable_info" v-html="item.enable_info"></div>
              </ul>
              <hr class="mx-1" />
              <ul class="px-2 mb-4">
                <li>{{ item.remark }}</li>
              </ul>
            </div>
          </div>
          <!-- <div class="column is-one-third">
            <div class="plan-1 has-text-weight-semibold py-4 px-2">
              <div class="columns is-mobile">
                <div class="column is-9">
                  <h3 class="title is-3 has-text-white mt-4 ml-2">Zebra</h3>
                  <h1 class="title is-1 has-text-white ml-2">$199</h1>
                </div>
                <img
                  src="@/assets/img/zebra.svg"
                  alt=""
                  class="image is-128x128 decoration"
                />
              </div>
              <ul class="px-2">
                <li>Up to 10 kids with 10 adults</li>
                <li>2-hour party room</li>
                <li>2-hour same time play</li>
                <li>10% OFF with Unlimited Pass</li>
              </ul>
              <hr class="mx-1" />
              <ul class="px-2">
                <li>$50 deposit when booking</li>
                <li>$11.99 / add'l kid</li>
                <li>$7.99 / add'l toddler</li>
                <li>$5.99 / add'l adult</li>
                <li>$100 / add'l hour for party room and play</li>
                <li>$50 / add'l hour for play only</li>
              </ul>
              <hr class="mx-1" />
              <ul class="px-2">
                <li class="mb-4">
                  Available:
                  <ul class="pl-2">
                    <li>MONs - SUNs: Business hours</li>
                  </ul>
                </li>
                <li>Book anytime</li>
                <li>Reschedule or cancel 1 week prior</li>
              </ul>
              <hr class="mx-1" />
              <ul class="px-2 mb-4">
                <li>Decorations are only allowed in the party room.</li>
              </ul>
            </div>
          </div>
          <div class="column is-one-third">
            <div class="plan-2 has-text-weight-semibold py-4 px-2">
              <div class="columns is-mobile">
                <div class="column is-9">
                  <h3 class="title is-3 has-text-white mt-4 ml-2">Gorilla</h3>
                  <h1 class="title is-1 has-text-white ml-2">$279</h1>
                </div>
                <img
                  src="@/assets/img/gorilla.svg"
                  alt=""
                  class="image is-128x128 decoration"
                />
              </div>
              <ul class="px-2">
                <li>Up to 20 kids with 20 adults</li>
                <li>2-hour party room</li>
                <li>2-hour same time play</li>
                <li>10% OFF with Unlimited Pass</li>
              </ul>
              <hr class="mx-1" />
              <ul class="px-2">
                <li>$50 deposit when booking</li>
                <li>$11.99 / add'l kid</li>
                <li>$7.99 / add'l toddler</li>
                <li>$5.99 / add'l adult</li>
                <li>$150 / add'l hour for party room and play</li>
                <li>$100 / add'l hour for play only</li>
              </ul>
              <hr class="mx-1" />
              <ul class="px-2">
                <li class="mb-4">
                  Available:
                  <ul class="pl-2">
                    <li>MONs - SUNs: Business hours</li>
                  </ul>
                </li>
                <li>Book anytime</li>
                <li>Reschedule or cancel 1 week prior</li>
              </ul>
              <hr class="mx-1" />
              <ul class="px-2 mb-4">
                <li>Decorations are only allowed in the party room.</li>
              </ul>
            </div>
          </div>
          <div class="column is-one-third">
            <div class="plan-3 has-text-weight-semibold py-4 px-2">
              <div class="columns is-mobile">
                <div class="column is-9">
                  <h3 class="title is-3 has-text-white mt-4 ml-2">Eagle</h3>
                  <h1 class="title is-1 has-text-white ml-2">$749</h1>
                </div>
                <img
                  src="@/assets/img/eagle.svg"
                  alt=""
                  class="image is-128x128 decoration"
                />
              </div>
              <ul class="px-2">
                <li>No limit on guest number</li>
                <li>2-hour entire facility</li>
                <li>2-hour same time play</li>
                <li>No discount available</li>
              </ul>
              <hr class="mx-1" />
              <ul class="px-2">
                <li>$100 deposit when booking</li>
                <li>$300 / add'l hour</li>
              </ul>
              <hr class="mx-1" />
              <ul class="px-2">
                <li class="mb-4">
                  Available:
                  <ul class="pl-2">
                    <li>
                      MONs - THURs: 10 AM - 12 PM, 4 - 6 PM &amp; 6:15 - 8:15 PM
                    </li>
                    <li>FRIs &amp; SATs: 6:15 - 8:15 PM</li>
                    <li>SUNs: 5:15 - 7:15 PM</li>
                  </ul>
                </li>
                <li>Book anytime</li>
                <li>Reschedule or cancel 1 week prior</li>
              </ul>
              <hr class="mx-1" />
              <ul class="px-2 mb-4">
                <li>
                  Decorations are allowed in the party room and at the front
                  door.
                </li>
              </ul>
            </div>
          </div> -->
        </div>
      </div>
      <div class="has-text-centered">
        <a
          :href="`tel:${config.phone}`"
          class="button is-primary mx-2 my-2 has-text-weight-medium"
          :style="{
            backgroundColor : config.button_bgcolor
          }"
          >Call Us</a
        >
        <div
          @click="openDialog"
          class="button is-primary is-rounded has-text-weight-semibold mb-3"
          :style="{
            backgroundColor : config.button_bgcolor
          }"
        >
          Booking Online
        </div>
      </div>
    </section>
    <section class="section feature has-background-info-light">
      <div class="container py-4">
        <div class="columns is-multiline">
          <div class="column is-6 ng-star-inserted">
            <img
              class="image is-48x48 mb-3 mt-3"
              src="@/assets/img/pizza.svg"
              alt="- 1 -"
            />
            <h3 class="title is-spaced is-3">Party Supply and Food</h3>
            <div
              safehtmlpipe=""
              class="subtitle is-6 has-text-weight-medium has-text-justified has-text-grey-darker"
            >
              <div
                class="subtitle is-6 has-text-weight-medium has-text-justified has-text-grey-darker"
              >
                Complimentary party supplies (table cloths, plates, cups,
                napkins, and utensils).
              </div>
              <div
                class="subtitle is-6 has-text-weight-medium has-text-justified has-text-grey-darker"
              >
                Free grip socks&nbsp;for kids (not for adults).
              </div>
              <div
                class="subtitle is-6 has-text-weight-medium has-text-justified has-text-grey-darker"
              >
                You could bring your own food, drink, cake, cutter, &amp;
                candles.
              </div>
            </div>
          </div>
          <div class="column is-6 ng-star-inserted">
            <img
              class="image is-48x48 mb-3 mt-3"
              src="@/assets/img/tree.svg"
              alt="- 2 -"
            />
            <h3 class="title is-spaced is-3">Decorations Policy</h3>
            <div
              safehtmlpipe=""
              class="subtitle is-6 has-text-weight-medium has-text-justified has-text-grey-darker"
            >
              <div
                class="subtitle is-6 has-text-weight-medium has-text-justified has-text-grey-darker"
              >
                Set up and clean up MUST occur within the allotted time window.
                No confetti.
              </div>
              <div
                class="subtitle is-6 has-text-weight-medium has-text-justified has-text-grey-darker"
              >
                We don't provide themed decorations until further notice.
              </div>
            </div>
          </div>
          <div class="column is-6 ng-star-inserted">
            <img
              class="image is-48x48 mb-3 mt-3"
              src="@/assets/img/check.svg"
              alt="- 3 -"
            />
            <h3 class="title is-spaced is-3">Requirements for Guests</h3>
            <div
              safehtmlpipe=""
              class="subtitle is-6 has-text-weight-medium has-text-justified has-text-grey-darker"
            >
              <div
                class="subtitle is-6 has-text-weight-medium has-text-justified has-text-grey-darker"
              >
                Signed waiver are required for all guests (even not play).
              </div>
              <div
                class="subtitle is-6 has-text-weight-medium has-text-justified has-text-grey-darker"
              >
                Grip socks are required for all kid guests (even not play).
              </div>
              <div
                class="subtitle is-6 has-text-weight-medium has-text-justified has-text-grey-darker"
              >
                Adults should wear own grip socks or regular socks, or purchase
                grip socks in store. No shoes in the playground and party room
                inside the playground.
              </div>
            </div>
          </div>
          <div class="column is-6 ng-star-inserted">
            <img
              class="image is-48x48 mb-3 mt-3"
              src="@/assets/img/cancel.svg"
              alt="- 4 -"
            />
            <h3 class="title is-spaced is-3">Cancellation Policy</h3>
            <div
              safehtmlpipe=""
              class="subtitle is-6 has-text-weight-medium has-text-justified has-text-grey-darker"
            >
              <div
                class="subtitle is-6 has-text-weight-medium has-text-justified has-text-grey-darker"
              >
                If cancellation is done within the allotted time, the
                reservation deposit will be given a playground credit towards an
                event or play pass. This credit will not expire and can be used
                for an event in the future or given as a gift.
              </div>
              <div
                class="subtitle is-6 has-text-weight-medium has-text-justified has-text-grey-darker"
              >
                If you fail to give notice within the allotted time, your
                RESERVATION DEPOSIT will be NOT BE CREDITED TOWARDS ANY EVENT OR
                PLAY PASS NOR WILL IT BE REFUNDED BACK TO YOU.
              </div>
              <div
                class="subtitle is-6 has-text-weight-medium has-text-justified has-text-grey-darker"
              >
                If your guests don’t show up for any reason, please understand
                that you have a minimum number to meet and the total balance
                remains despite guest changes.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="has-text-centered">
        <a
          :href="`tel:${config.phone}`"
          class="button is-primary has-text-weight-semibold mt-4"
          :style="{
            backgroundColor : config.button_bgcolor
          }"
          >Call Us</a
        >
      </div>
    </section>
    <section class="section past-events">
      <div class="container py-4">
        <h2 class="title has-text-centered">Past Events</h2>
        <h4 class="subtitle has-text-centered mb-6">
          <span class="has-text-primary">❤</span> Thanks for sharing these
          special moments with us
          <span class="has-text-primary">❤</span>
        </h4>
        <swiper
          class="is-hidden-tablet swiper-container swiper-container-initialized swiper-container-horizontal swiper-container-pointer-events"
        >
          <div
            class="swiper-wrapper"
            id="swiper-wrapper-ccdc12c7bfb9f435"
            aria-live="polite"
            style="transition-duration: 0ms"
          >
            <div
              data-swiper-slide-index="0"
              class="swiper-slide ng-star-inserted"
            >
              <div class="card ng-star-inserted">
                <div class="card-image">
                  <figure class="image is-rounded">
                    <img
                      src="@/assets/img/Nicolas.png"
                      alt="Nicolas' MineCraft-themed 6th Birthday Party"
                    />
                  </figure>
                </div>
                <div class="card-content">
                  <div
                    class="content has-text-grey-darker has-text-weight-medium"
                  >
                    <p>Nicolas' MineCraft-themed 6th Birthday Party</p>
                    <p>
                      <img
                        src="!/assets/img/logo-INS.png"
                        alt=""
                        class="is-inline-block mr-2"
                        style="vertical-align: middle; height: 16px"
                      /><a
                        target=" _blank"
                        class="has-text-grey-darker"
                        href="https://www.instagram.com/p/CG5M_aQDI1X"
                        >@daniele_luna</a
                      >
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              data-swiper-slide-index="1"
              class="swiper-slide ng-star-inserted"
            >
              <div class="card ng-star-inserted">
                <div class="card-image">
                  <figure class="image is-rounded">
                    <img
                      src="@/assets/img/Maria.png"
                      alt="Little Princess Elsa Maria's Frozen Adventure on Her 6th Birthday"
                    />
                  </figure>
                </div>
                <div class="card-content">
                  <div
                    class="content has-text-grey-darker has-text-weight-medium"
                  >
                    <p>
                      Little Princess Elsa Maria's Frozen Adventure on Her 6th
                      Birthday
                    </p>
                    <p>
                      <img
                        src="@/assets/img/logo-INS.png"
                        alt=""
                        class="is-inline-block mr-2"
                        style="vertical-align: middle; height: 16px"
                      /><a
                        target=" _blank"
                        class="has-text-grey-darker"
                        href="https://www.instagram.com/p/CJ5KjzVgIXm"
                        >@mariajosenoeto</a
                      >
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              data-swiper-slide-index="2"
              class="swiper-slide ng-star-inserted"
            >
              <div class="card ng-star-inserted">
                <div class="card-image">
                  <figure class="image is-rounded">
                    <img
                      src="@/assets/img/Boston.png"
                      alt="Boston's Celebrating His 6th Birthday"
                    />
                  </figure>
                </div>
                <div class="card-content">
                  <div
                    class="content has-text-grey-darker has-text-weight-medium"
                  >
                    <p>Boston's Celebrating His 6th Birthday</p>
                    <p>
                      <img
                        src="@/assets/img/logo-INS.png"
                        alt=""
                        class="is-inline-block mr-2"
                        style="vertical-align: middle; height: 16px"
                      /><a
                        target=" _blank"
                        class="has-text-grey-darker"
                        href="https://www.instagram.com/p/CIV_bTXhh-laogSxANm1lBUAFbi_4m0bS3FSx80/"
                        >@hotrosyposy</a
                      >
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              data-swiper-slide-index="3"
              class="swiper-slide ng-star-inserted"
            >
              <div class="card ng-star-inserted">
                <div class="card-image">
                  <figure class="image is-rounded">
                    <img
                      src="@/assets/img/Noah.png"
                      alt="Noah's 4th Birthday Pac-Man themed Party"
                    />
                  </figure>
                </div>
                <div class="card-content">
                  <div
                    class="content has-text-grey-darker has-text-weight-medium"
                  >
                    <p>Noah's 4th Birthday Pac-Man themed Party</p>
                    <p>
                      <img
                        src="@/assets/img/logo-INS.png"
                        alt=""
                        class="is-inline-block mr-2"
                        style="vertical-align: middle; height: 16px"
                      /><a
                        target=" _blank"
                        class="has-text-grey-darker"
                        href="https://www.instagram.com/p/CHdZBvoBPreAdM_iPZfGBXLHQaha9vDC-FM2Ec0/"
                        >@iri_salculescu</a
                      >
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <span
            class="swiper-notification"
            aria-live="assertive"
            aria-atomic="true"
          ></span
        ></swiper>
        <div class="columns is-multiline is-centered is-hidden-mobile">
          <div class="column is-3-desktop is-half-tablet ng-star-inserted">
            <div class="card">
              <div class="card-image">
                <figure class="image is-rounded">
                  <img
                    src="@/assets/img/Nicolas.png"
                    alt="Nicolas' MineCraft-themed 6th Birthday Party"
                  />
                </figure>
              </div>
              <div class="card-content">
                <div
                  class="content has-text-grey-darker has-text-weight-medium"
                >
                  <p>Nicolas' MineCraft-themed 6th Birthday Party</p>
                  <p>
                    <img
                      src="@/assets/img/logo-INS.png"
                      alt=""
                      class="is-inline-block mr-2"
                      style="vertical-align: middle; height: 16px"
                    /><a
                      target=" _blank"
                      class="has-text-grey-darker"
                      href="https://www.instagram.com/p/CG5M_aQDI1X"
                      >@daniele_luna</a
                    >
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-3-desktop is-half-tablet ng-star-inserted">
            <div class="card">
              <div class="card-image">
                <figure class="image is-rounded">
                  <img
                    src="@/assets/img/Maria.png"
                    alt="Little Princess Elsa Maria's Frozen Adventure on Her 6th Birthday"
                  />
                </figure>
              </div>
              <div class="card-content">
                <div
                  class="content has-text-grey-darker has-text-weight-medium"
                >
                  <p>
                    Little Princess Elsa Maria's Frozen Adventure on Her 6th
                    Birthday
                  </p>
                  <p>
                    <img
                      src="@/assets/img/logo-INS.png"
                      alt=""
                      class="is-inline-block mr-2"
                      style="vertical-align: middle; height: 16px"
                    /><a
                      target=" _blank"
                      class="has-text-grey-darker"
                      href="https://www.instagram.com/p/CJ5KjzVgIXm"
                      >@mariajosenoeto</a
                    >
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-3-desktop is-half-tablet ng-star-inserted">
            <div class="card">
              <div class="card-image">
                <figure class="image is-rounded">
                  <img
                    src="@/assets/img/Boston.png"
                    alt="Boston's Celebrating His 6th Birthday"
                  />
                </figure>
              </div>
              <div class="card-content">
                <div
                  class="content has-text-grey-darker has-text-weight-medium"
                >
                  <p>Boston's Celebrating His 6th Birthday</p>
                  <p>
                    <img
                      src="@/assets/img/logo-INS.png"
                      alt=""
                      class="is-inline-block mr-2"
                      style="vertical-align: middle; height: 16px"
                    /><a
                      target=" _blank"
                      class="has-text-grey-darker"
                      href="https://www.instagram.com/p/CIV_bTXhh-laogSxANm1lBUAFbi_4m0bS3FSx80/"
                      >@hotrosyposy</a
                    >
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-3-desktop is-half-tablet ng-star-inserted">
            <div class="card">
              <div class="card-image">
                <figure class="image is-rounded">
                  <img
                    src="@/assets/img/Noah.png"
                    alt="Noah's 4th Birthday Pac-Man themed Party"
                  />
                </figure>
              </div>
              <div class="card-content">
                <div
                  class="content has-text-grey-darker has-text-weight-medium"
                >
                  <p>Noah's 4th Birthday Pac-Man themed Party</p>
                  <p>
                    <img
                      src="@/assets/img/logo-INS.png"
                      alt=""
                      class="is-inline-block mr-2"
                      style="vertical-align: middle; height: 16px"
                    /><a
                      target=" _blank"
                      class="has-text-grey-darker"
                      href="https://www.instagram.com/p/CHdZBvoBPreAdM_iPZfGBXLHQaha9vDC-FM2Ec0/"
                      >@iri_salculescu</a
                    >
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section has-background-info-light">
      <div class="container py-4">
        <h2 class="title has-text-centered mb-6">Invitation Cards</h2>
        <div class="columns is-centered">
          <div class="column is-5 has-text-centered">
            <div class="card mb-4">
              <div class="card-image">
                <figure class="image is-rounded">
                  <img
                    src="@/assets/img/Invitation-Blue.png"
                    alt="invitation-card-blue"
                  />
                </figure>
              </div>
            </div>
            <a
              href="/images/KidsTopia_InvitationCard_Blue_PersonalUseOnly.png"
              download="/images/KidsTopia_InvitationCard_Blue_PersonalUseOnly.png"
              class="button is-primary is-outlined has-text-weight-semibold my-4"
              :style="{ borderColor: config.button_bgcolor, '--hover-color': config.button_bgcolor ? config.button_bgcolor : '#de4c50', color: config.button_bgcolor }"
              >Download</a
            >
          </div>
          <div class="column is-5 has-text-centered">
            <div class="card mb-4">
              <div class="card-image">
                <figure class="image is-rounded">
                  <img
                    src="@/assets/img/Invitation-Red.png"
                    alt="invitation-card-red"
                  />
                </figure>
              </div>
            </div>
            <a
              href="/images/KidsTopia_InvitationCard_Red_PersonalUseOnly.png"
              download="/images/KidsTopia_InvitationCard_Red_PersonalUseOnly.png"
              class="button is-primary is-outlined has-text-weight-semibold my-4"
              :style="{ borderColor: config.button_bgcolor, '--hover-color': config.button_bgcolor ? config.button_bgcolor : '#de4c50', color: config.button_bgcolor }"
              >Download</a
            >
          </div>
        </div>
      </div>
    </section>
    <section class="section faq">
      <div class="container py-4">
        <h2 class="title has-text-centered mb-6">Frequently Asked Questions</h2>
        <swiper
          class="is-hidden-tablet swiper-container swiper-container-initialized swiper-container-horizontal swiper-container-pointer-events"
        >
          <div
            class="swiper-wrapper"
            id="swiper-wrapper-26e5f9fcb6d7cce7"
            aria-live="polite"
            style="transition-duration: 0ms"
          >
            <div
              data-swiper-slide-index="0"
              class="swiper-slide ng-star-inserted"
            >
              <div class="card block ng-star-inserted">
                <div class="card-content">
                  <div class="media">
                    <div class="media-left">
                      <img
                        src="@/assets/img/question.svg"
                        alt=""
                        class="image is-24x24 mr-2"
                      />
                    </div>
                    <div class="media-content">
                      <h3 class="title is-5">
                        How could I check the time availability of party?
                      </h3>
                      <p class="has-text-justified mb-2 has-text-grey-darker">
                        Just call us 801-601-8341 or send an email to
                        party@kidstopia-us.com . An online calendar will be
                        coming soon. Sorry for the inconvenience right now.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              data-swiper-slide-index="1"
              class="swiper-slide ng-star-inserted"
            >
              <div class="card block ng-star-inserted">
                <div class="card-content">
                  <div class="media">
                    <div class="media-left">
                      <img
                        src="@/assets/img/question.svg"
                        alt=""
                        class="image is-24x24 mr-2"
                      />
                    </div>
                    <div class="media-content">
                      <h3 class="title is-5">
                        Is there any discount on the party package?
                      </h3>
                      <p class="has-text-justified mb-2 has-text-grey-darker">
                        Our Unlimited Pass Subscriber enjoy 10% off on those two
                        packages. No discount available for Eagle package. We do
                        not have any other offers for now. You could follow us
                        on Instagram @kidstopia_utah / Facebook @KidsTopiaUtah
                        to get the update promotion information.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              data-swiper-slide-index="2"
              class="swiper-slide ng-star-inserted"
            >
              <div class="card block ng-star-inserted">
                <div class="card-content">
                  <div class="media">
                    <div class="media-left">
                      <img
                        src="@/assets/img/question.svg"
                        alt=""
                        class="image is-24x24 mr-2"
                      />
                    </div>
                    <div class="media-content">
                      <h3 class="title is-5">
                        Could I book business off hours for a party?
                      </h3>
                      <p class="has-text-justified mb-2 has-text-grey-darker">
                        It depends. Just give us a call and let us figure it out
                        together.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              data-swiper-slide-index="3"
              class="swiper-slide ng-star-inserted"
            >
              <div class="card block ng-star-inserted">
                <div class="card-content">
                  <div class="media">
                    <div class="media-left">
                      <img
                        src="@/assets/img/question.svg"
                        alt=""
                        class="image is-24x24 mr-2"
                      />
                    </div>
                    <div class="media-content">
                      <h3 class="title is-5">
                        What kind of payment methods do you guys take for the
                        party deposit? Could I transfer it online?
                      </h3>
                      <p class="has-text-justified mb-2 has-text-grey-darker">
                        Yes, of course. Our staff will handle the payment
                        information to you after confirming the party
                        information. You do not have to visit our place to pay
                        the deposit.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <span
            class="swiper-notification"
            aria-live="assertive"
            aria-atomic="true"
          ></span
        ></swiper>
        <div class="columns is-centered is-hidden-mobile">
          <div class="column is-10">
            <mat-accordion class="mat-accordion"
              ><mat-expansion-panel
                hidetoggle=""
                class="mat-expansion-panel my-1 ng-tns-c56-8 ng-star-inserted"
                ><mat-expansion-panel-header
                  role="button"
                  class="mat-expansion-panel-header mat-focus-indicator ng-tns-c57-9 ng-tns-c56-8 mat-expansion-toggle-indicator-after ng-star-inserted"
                  id="mat-expansion-panel-header-4"
                  tabindex="0"
                  aria-controls="cdk-accordion-child-4"
                  aria-expanded="false"
                  aria-disabled="false"
                  ><span class="mat-content ng-tns-c57-9"
                    ><mat-panel-title
                      class="mat-expansion-panel-header-title ng-tns-c57-9"
                      @click="clickMat(0)"
                      ><img
                        src="@/assets/img/question.svg"
                        alt=""
                        class="image is-24x24 mr-2"
                      />
                      <h3 class="title is-5">
                        How could I check the time availability of party?
                      </h3></mat-panel-title
                    ></span
                  ></mat-expansion-panel-header
                >
                <div
                  role="region"
                  class="mat-expansion-panel-content ng-tns-c56-8 ng-trigger ng-trigger-bodyExpansion"
                  id="cdk-accordion-child-4"
                  aria-labelledby="mat-expansion-panel-header-4"
                  :style="{
                    height: this.matIndex == 0 ? 'auto' : '0px',
                    visibility: this.matIndex == 0 ? '' : 'hidden',
                  }"
                >
                  <div class="mat-expansion-panel-body ng-tns-c56-8">
                    <p
                      class="subtitle is-6 has-text-justified has-text-grey-darker ng-tns-c56-8"
                    >
                      Just call us 801-601-8341 or send an email to
                      party@kidstopia-us.com . An online calendar will be coming
                      soon. Sorry for the inconvenience right now.
                    </p>
                  </div>
                </div></mat-expansion-panel
              ><mat-expansion-panel
                hidetoggle=""
                class="mat-expansion-panel my-1 ng-tns-c56-10 ng-star-inserted"
                ><mat-expansion-panel-header
                  role="button"
                  class="mat-expansion-panel-header mat-focus-indicator ng-tns-c57-11 ng-tns-c56-10 mat-expansion-toggle-indicator-after ng-star-inserted"
                  id="mat-expansion-panel-header-5"
                  tabindex="0"
                  aria-controls="cdk-accordion-child-5"
                  aria-expanded="false"
                  aria-disabled="false"
                  ><span class="mat-content ng-tns-c57-11"
                    ><mat-panel-title
                      class="mat-expansion-panel-header-title ng-tns-c57-11"
                      @click="clickMat(0)"
                      ><img
                        src="@/assets/img/question.svg"
                        alt=""
                        class="image is-24x24 mr-2"
                      />
                      <h3 class="title is-5">
                        Is there any discount on the party package?
                      </h3></mat-panel-title
                    ></span
                  ></mat-expansion-panel-header
                >
                <div
                  role="region"
                  class="mat-expansion-panel-content ng-tns-c56-10 ng-trigger ng-trigger-bodyExpansion"
                  id="cdk-accordion-child-5"
                  aria-labelledby="mat-expansion-panel-header-5"
                  :style="{
                    height: this.matIndex == 1 ? 'auto' : '0px',
                    visibility: this.matIndex == 1 ? '' : 'hidden',
                  }"
                >
                  <div class="mat-expansion-panel-body ng-tns-c56-10">
                    <p
                      class="subtitle is-6 has-text-justified has-text-grey-darker ng-tns-c56-10"
                    >
                      Our Unlimited Pass Subscriber enjoy 10% off on those two
                      packages. No discount available for Eagle package. We do
                      not have any other offers for now. You could follow us on
                      Instagram @kidstopia_utah / Facebook @KidsTopiaUtah to get
                      the update promotion information.
                    </p>
                  </div>
                </div></mat-expansion-panel
              ><mat-expansion-panel
                hidetoggle=""
                class="mat-expansion-panel my-1 ng-tns-c56-12 ng-star-inserted"
                ><mat-expansion-panel-header
                  role="button"
                  class="mat-expansion-panel-header mat-focus-indicator ng-tns-c57-13 ng-tns-c56-12 mat-expansion-toggle-indicator-after ng-star-inserted"
                  id="mat-expansion-panel-header-6"
                  tabindex="0"
                  aria-controls="cdk-accordion-child-6"
                  aria-expanded="false"
                  aria-disabled="false"
                  ><span class="mat-content ng-tns-c57-13"
                    ><mat-panel-title
                      class="mat-expansion-panel-header-title ng-tns-c57-13"
                      @click="clickMat(2)"
                      ><img
                        src="@/assets/img/question.svg"
                        alt=""
                        class="image is-24x24 mr-2"
                      />
                      <h3 class="title is-5">
                        Could I book business off hours for a party?
                      </h3></mat-panel-title
                    ></span
                  ></mat-expansion-panel-header
                >
                <div
                  role="region"
                  class="mat-expansion-panel-content ng-tns-c56-12 ng-trigger ng-trigger-bodyExpansion"
                  id="cdk-accordion-child-6"
                  aria-labelledby="mat-expansion-panel-header-6"
                  :style="{
                    height: this.matIndex == 2 ? 'auto' : '0px',
                    visibility: this.matIndex == 2 ? '' : 'hidden',
                  }"
                >
                  <div class="mat-expansion-panel-body ng-tns-c56-12">
                    <p
                      class="subtitle is-6 has-text-justified has-text-grey-darker ng-tns-c56-12"
                    >
                      It depends. Just give us a call and let us figure it out
                      together.
                    </p>
                  </div>
                </div></mat-expansion-panel
              ><mat-expansion-panel
                hidetoggle=""
                class="mat-expansion-panel my-1 ng-tns-c56-14 ng-star-inserted"
                ><mat-expansion-panel-header
                  role="button"
                  class="mat-expansion-panel-header mat-focus-indicator ng-tns-c57-15 ng-tns-c56-14 mat-expansion-toggle-indicator-after ng-star-inserted"
                  id="mat-expansion-panel-header-7"
                  tabindex="0"
                  aria-controls="cdk-accordion-child-7"
                  aria-expanded="false"
                  aria-disabled="false"
                  ><span class="mat-content ng-tns-c57-15"
                    ><mat-panel-title
                      class="mat-expansion-panel-header-title ng-tns-c57-15"
                      @click="clickMat(3)"
                      ><img
                        src="@/assets/img/question.svg"
                        alt=""
                        class="image is-24x24 mr-2"
                      />
                      <h3 class="title is-5">
                        What kind of payment methods do you guys take for the
                        party deposit? Could I transfer it online?
                      </h3></mat-panel-title
                    ></span
                  ></mat-expansion-panel-header
                >
                <div
                  role="region"
                  class="mat-expansion-panel-content ng-tns-c56-14 ng-trigger ng-trigger-bodyExpansion"
                  id="cdk-accordion-child-7"
                  aria-labelledby="mat-expansion-panel-header-7"
                  :style="{
                    height: this.matIndex == 3 ? 'auto' : '0px',
                    visibility: this.matIndex == 3 ? '' : 'hidden',
                  }"
                >
                  <div class="mat-expansion-panel-body ng-tns-c56-14">
                    <p
                      class="subtitle is-6 has-text-justified has-text-grey-darker ng-tns-c56-14"
                    >
                      Yes, of course. Our staff will handle the payment
                      information to you after confirming the party information.
                      You do not have to visit our place to pay the deposit.
                    </p>
                  </div>
                </div></mat-expansion-panel
              ></mat-accordion
            >
          </div>
        </div>
        <div class="has-text-centered mt-5">
          <h4 class="title is-4 is-hidden-tablet">
            Have more questions? Or want to book a party now?
          </h4>
          <h4 class="title is-4 is-hidden-mobile">
            Your questions are not here? Or want to book a party now?
          </h4>
          <a
            :href="`tel:${config.phone}`"
            class="button is-primary mx-2 my-2 has-text-weight-medium"
            :style="{
              backgroundColor : config.button_bgcolor
            }"
            >Call Us</a
          ><a
            :href="`mailto:${config.email}`"
            class="button has-text-weight-medium mx-2 my-2"
            >Inquiry via Email</a
          >
        </div>
      </div>
    </section>
    <Book v-if="visible" :dialogVisible="visible" />
  </div>
</template>
<script>
import { PartyPackageList } from "@/server/api.js";
import store from "@/store";
import Book from "@/components/Book.vue";
import zebra from "../../assets/img/zebra.svg";
import gorilla from "../../assets/img/gorilla.svg";
import eagle from "../../assets/img/eagle.svg";

export default {
  components: { Book },
  computed: {
    config() {
      return store.state.global.configList || {};
    },
  },
  data() {
    return {
      visible: false,
      items: [],
      info: {},
      img: [zebra, gorilla, eagle],
      background: [
        "linear-gradient(-45deg,#f36c31,#faca49)",
        "linear-gradient(-45deg,#de4c50,#f28859)",
        "linear-gradient(-45deg,#5c7dce,#6db4ee)",
      ],
      matIndex: null,
      success: false
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    async getInfo() {
      try {
        const { status, data } = await PartyPackageList({});
        if (status == 0) {
          this.items = data.items;
          this.info = data.info;
          this.success = true;
          setTimeout(() => {
            var iframe = document.getElementsByTagName("iframe");
            for (let i = 0; i <= iframe.length - 1; i++) {
              iframe[i].style.width = "100%";
              iframe[i].style.height = "100%";
            }
          }, 0);
        }
      } catch (error) {}
    },
    openDialog() {
      // the shop is roy
      // if(this.config.id == 26) {
      //   window.open('https://kidstopia-roy.aluvii.com/event')
      // } else {
      this.visible = true;
      // }
    },
    closeDialog() {
      this.visible = false;
    },
    clickMat(index) {
      if (this.matIndex == index) {
        this.matIndex = null;
      } else {
        this.matIndex = index;
      }
    },
  },
};
</script>
<style scoped>
.hero-body,
.section {
  padding: 3rem 1.5rem;
}
.party-header {
  margin-top: 50px;
}
.container {
  flex-grow: 1;
  margin: 0 auto;
  position: relative;
  width: auto;
}

.button.is-primary.is-hovered,
.button.is-primary:hover {
  opacity: 0.8;
  border-color: transparent;
  color: #fff !important;
}
.button.is-primary.is-hovered,
.button.is-primary:hover {
  opacity: 0.8;
  border-color: transparent;
  color: #fff !important;
}
.enable_info {
  white-space: pre-line;
}
@media (min-width: 768px) {
  .card {
    margin-top: 1rem;
    border: none;
    border-radius: 10px;
    box-shadow: 9px 9px 19px #c9c9c9, -9px -9px 19px #fff;
  }
  .card:hover {
    top: -4px;
    left: -1px;
    box-shadow: 9px 9px 29px #b9b9b9, -9px -9px 29px #fff;
    transition: all 0.5s ease-in-out;
  }
}
@media print, screen and (min-width: 769px) {
  .columns:not(.is-desktop) {
    display: flex;
  }
  .is-hidden-tablet {
    display: none !important;
  }
  .column.is-one-third,
  .column.is-one-third-tablet {
    flex: none;
    width: 33.3333%;
  }
  .column.is-9,
  .column.is-9-tablet {
    flex: none;
    width: 75%;
  }
  .column.is-6,
  .column.is-6-tablet {
    flex: none;
    width: 50%;
  }
  .is-hidden-tablet {
    display: none !important;
  }
  .column.is-5,
  .column.is-5-tablet {
    flex: none;
    width: 41.6666666667%;
  }
  .column.is-10,
  .column.is-10-tablet {
    flex: none;
    width: 83.3333333333%;
  }
}
@media screen and (min-width: 1024px) {
  .container {
    max-width: 960px;
  }
  .column.is-3-desktop {
    flex: none;
    width: 25%;
  }
}
@media screen and (min-width: 1408px) {
  .container:not(.is-max-desktop):not(.is-max-widescreen) {
    max-width: 1344px;
  }
}
.columns {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
  margin-top: -1.5rem;
}
.columns:not(:last-child) {
  margin-bottom: calc(1.5rem - 1.5rem);
}

.columns.is-vcentered {
  align-items: center;
}
.column {
  display: block;
  flex-basis: 0;
  flex-grow: 1;
  flex-shrink: 1;
  padding: 1.5rem;
  box-sizing: border-box;
}
.subtitle,
.title {
  word-break: break-word;
}
.title {
  color: #363636;
  font-family: Rubik, sans-serif;
  font-size: 2rem;
  font-weight: 600;
  line-height: 1.125;
}
.block:not(:last-child),
.box:not(:last-child),
.breadcrumb:not(:last-child),
.content:not(:last-child),
.highlight:not(:last-child),
.level:not(:last-child),
.message:not(:last-child),
.notification:not(:last-child),
.pagination:not(:last-child),
.progress:not(:last-child),
.subtitle:not(:last-child),
.table-container:not(:last-child),
.table:not(:last-child),
.tabs:not(:last-child),
.title:not(:last-child) {
  margin-bottom: 1.5rem;
}
.title.is-1 {
  font-size: 3rem;
}
.subtitle {
  color: #757763;
  font-family: Quicksand, sans-serif;
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 1.25;
}
.has-text-justified {
  text-align: justify !important;
}
.has-text-weight-medium {
  font-weight: 500 !important;
}
.block:not(:last-child),
.box:not(:last-child),
.breadcrumb:not(:last-child),
.content:not(:last-child),
.highlight:not(:last-child),
.level:not(:last-child),
.message:not(:last-child),
.notification:not(:last-child),
.pagination:not(:last-child),
.progress:not(:last-child),
.subtitle:not(:last-child),
.table-container:not(:last-child),
.table:not(:last-child),
.tabs:not(:last-child),
.title:not(:last-child) {
  margin-bottom: 1.5rem;
}
a {
  color: #e55f61;
  cursor: pointer;
  text-decoration: none;
}
.button,
.file-cta,
.file-name,
.input,
.pagination-ellipsis,
.pagination-link,
.pagination-next,
.pagination-previous,
.select select,
.textarea {
  -moz-appearance: none;
  -webkit-appearance: none;
  align-items: center;
  border: 1px solid transparent;
  border-radius: 4px;
  box-shadow: none;
  display: inline-flex;
  font-size: 1rem;
  height: 2.5em;
  justify-content: flex-start;
  line-height: 1.5;
  padding: calc(0.5em - 1px) calc(0.75em - 1px);
  position: relative;
  vertical-align: center;
}
.button {
  background-color: #fff;
  border-color: #dbdbdb;
  border-width: 1px;
  color: #363636;
  cursor: pointer;
  justify-content: center;
  padding: calc(0.5em - 1px) 1em;
  text-align: center;
  white-space: nowrap;
  box-sizing: border-box;
}
.mt-4 {
  margin-top: 1rem !important;
}
.has-text-weight-semibold {
  font-weight: 600 !important;
}
.button.is-primary {
  background-color: #de4c50;
  border-color: transparent;
  color: #fff;
}
article,
aside,
figure,
footer,
header,
hgroup,
section {
  display: block;
}
.image {
  display: block;
  position: relative;
  height: auto !important;
}
.image img {
  display: block;
  height: 100%;
}
.image.is-16by9 {
  padding-top: 56.25%;
}

.help {
  display: block;
  font-size: 0.75rem;
  margin-top: 0.25rem;
}
.title.is-1 {
  font-size: 3rem;
}
.hero-body,
.section {
  padding: 3rem 1.5rem;
}
.has-text-white {
  color: #fff !important;
}

.pl-2,
.px-2 {
  padding-left: 0.5rem !important;
}
.px-2 {
  padding-right: 0.5rem !important;
}

.py-4 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}
.has-text-weight-semibold {
  font-weight: 600 !important;
}
.plan-1,
.plan-2,
.plan-3 {
  border: none;
  border-radius: 10px;
  box-shadow: 9px 9px 19px #c9c9c9, -9px -9px 19px #fff;
}
.plan-1 {
  background: linear-gradient(-45deg, #f36c31, #faca49);
}
.columns.is-mobile {
  display: flex;
}
.title.is-3 {
  font-size: 2rem;
}
.title.is-1 {
  font-size: 3rem;
}
img,
video {
  max-width: 100%;
}
.image.is-128x128 {
  height: 128px;
  width: 128px;
}
.decoration {
  position: relative;
  top: -60px;
  right: 50px;
  z-index: 1;
}
code,
hr {
  background-color: #f5f5f5;
}
hr {
  border: none;
  display: block;
  height: 2px;
  margin: 1.5rem 0;
}
.ml-1,
.mx-1 {
  margin-left: 0.25rem !important;
}
.mx-1 {
  margin-right: 0.25rem !important;
}
ul {
  list-style: none;
}
.plan-2 {
  background: linear-gradient(-45deg, #de4c50, #f28859);
}
.plan-3 {
  background: linear-gradient(-45deg, #5c7dce, #6db4ee);
}
.has-text-centered {
  text-align: center !important;
}
.price {
  margin-top: 5rem;
  margin-bottom: 3rem;
}
.mb-4 {
  margin-bottom: 1rem !important;
}
.has-background-info-light {
  background-color: #eef3fc !important;
}
.feature {
  margin-top: 3rem;
}
.image.is-48x48 {
  height: 48px;
  width: 48px;
}
.mb-3 {
  margin-bottom: 0.75rem !important;
}
.mt-3 {
  margin-top: 0.75rem !important;
}
.title:not(:last-child) {
  margin-bottom: 1.5rem;
}
.subtitle.is-6 {
  font-size: 1rem;
}
.has-text-grey-darker {
  color: #363636 !important;
}
.columns.is-multiline {
  flex-wrap: wrap;
}
.has-text-primary {
  color: #de4c50 !important;
}
.title:not(.is-spaced) + .subtitle {
  margin-top: -1.25rem;
}
.mb-6 {
  margin-bottom: 3rem !important;
}
swiper {
  display: block;
}
.swiper-container {
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: hidden;
  list-style: none;
  padding: 0;
  z-index: 1;
}
.swiper-container-pointer-events {
  touch-action: pan-y;
}
.card {
  background-color: #fff;
  border-radius: 0.25rem;
  box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, 0.1),
    0 0 0 1px rgba(10, 10, 10, 0.02);
  color: #757763;
  max-width: 100%;
  overflow: hidden;
  position: relative;
}
.card-image {
  display: block;
  position: relative;
}
.image img {
  display: block;
  height: auto;
  width: 100%;
}
.card-content {
  background-color: initial;
  padding: 1.5rem;
}
.has-text-weight-medium {
  font-weight: 500 !important;
}

.has-text-grey-darker {
  color: #363636 !important;
}
.is-inline-block {
  display: inline-block !important;
}
.mr-2 {
  margin-right: 0.5rem !important;
}

a {
  color: #e55f61;
  cursor: pointer;
  text-decoration: none;
}
.columns.is-centered {
  justify-content: center;
}
.button.is-primary.is-outlined {
  background-color: initial;
  border-color: #de4c50;
  color: #de4c50;
}
.my-4 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}
.button.is-primary.is-outlined.is-focused,
.button.is-primary.is-outlined.is-hovered,
.button.is-primary.is-outlined:focus,
.button.is-primary.is-outlined:hover {
  border-color: #de4c50;
  opacity: 0.8;
  color: #fff !important;
}

.mat-expansion-panel {
  box-sizing: content-box;
  display: block;
  margin: 0;
  border-radius: 4px;
  overflow: hidden;
  transition: margin 225ms cubic-bezier(0.4, 0, 0.2, 1),
    box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
}
.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}
.mat-accordion .mat-expansion-panel:first-of-type {
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
}

.mat-accordion .mat-expansion-panel:not(.mat-expanded),
.mat-accordion .mat-expansion-panel:not(.mat-expansion-panel-spacing) {
  border-radius: 0;
}
.mat-expansion-panel:not([class*="mat-elevation-z"]) {
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
}

.mat-expansion-panel {
  background: #fff;
  color: rgba(0, 0, 0, 0.87);
}
.mat-expansion-panel-header {
  font-family: Roboto, Helvetica Neue, sans-serif;
  font-size: 15px;
  font-weight: 400;
}
.mat-focus-indicator,
.mat-mdc-focus-indicator {
  position: relative;
}

.mat-expansion-panel-header {
  height: 48px;
}

.mat-expansion-panel-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 24px;
  border-radius: inherit;
  transition: height 225ms cubic-bezier(0.4, 0, 0.2, 1);
}

.mat-content {
  display: flex;
  flex: 1;
  flex-direction: row;
  overflow: hidden;
}
.mat-expansion-panel-header-title {
  color: rgba(0, 0, 0, 0.87);
}
.mat-expansion-panel-header-title,
.mat-expansion-panel-header-description {
  display: flex;
  flex-grow: 1;
  margin-right: 16px;
}
.mat-expansion-panel-header:not([aria-disabled="true"]) {
  cursor: pointer;
}

.image.is-24x24 {
  height: 24px;
  width: 24px;
}
.title.is-5 {
  font-size: 1.25rem;
}
.mt-5 {
  margin-top: 1.5rem !important;
}
.title.is-4 {
  font-size: 1.5rem;
}
.mx-2 {
  margin-right: 0.5rem !important;
}
.ml-2,
.mx-2 {
  margin-left: 0.5rem !important;
}
.columns.is-mobile > .column.is-9 {
  flex: none;
  width: 75%;
}
.media {
  align-items: flex-start;
  display: flex;
  text-align: inherit;
}
.media-left {
  margin-right: 1rem;
}
.media-left,
.media-right {
  flex-basis: auto;
  flex-grow: 0;
  flex-shrink: 0;
}
@media screen and (max-width: 768px) {
  .is-hidden-mobile {
    display: none !important;
  }
  .plan-2,
  .plan-3 {
    margin-top: 3rem;
  }
}
.is-16by9 {
  padding-top: 56.25%;
}
.iframe-wrap {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/pricing/party.vue